{
  "title": "Terminal logs",
  "columns": {
    "session_id": "Session ID",
    "ci_name": "CI Name",
    "host": "Host",
    "username": "User",
    "updated_at": "Date",
    "actions": "Actions"
  },
  "modal": {
    "title": "Terminal log"
  }
}